import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { getResourceKey } from '../../../utils/utils';
import { createTalkingPoint, type TalkingPointDto, type TalkingPointRequestDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useCreateTalkingPoint = (): UseMutationResult<TalkingPointDto, AxiosError, TalkingPointRequestDto> => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload) => {
            payload.key = getResourceKey(payload.name.EN);

            return createTalkingPoint({ body: payload }).then((result) => result.data!);
        },
        onSuccess: (savedTalkingPoint) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.talkingPoints() });
            showSuccessToast(t('successActionGeneric'));
            navigate({
                pathname: '/content-admin/talking-points',
                search: `?point=${savedTalkingPoint.id}`,
            });
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
